// SPDX-License-Identifier: MIT
import { clamp } from './math.ts';
export type Ease = (t: number) => number;
export const linear: Ease = (t) => clamp(t);
export const inQuad: Ease = (t) => clamp(t) ** 2;
export const outQuad: Ease = (t) => 1 - (1 - clamp(t)) ** 2;
export const inOutQuad: Ease = (t) => ((t = clamp(t)) < 0.5 ? 2 * t * t : 1 - (-2 * t + 2) ** 2 / 2);
export const inCubic: Ease = (t) => clamp(t) ** 3;
export const outCubic: Ease = (t) => 1 - (1 - clamp(t)) ** 3;
export const inOutCubic: Ease = (t) => ((t = clamp(t)) < 0.5 ? 4 * t ** 3 : 1 - (-2 * t + 2) ** 3 / 2);
export const outQuart: Ease = (t) => 1 - (1 - clamp(t)) ** 4;
export const inExpo: Ease = (t) => ((t = clamp(t)) === 0 ? 0 : 2 ** (10 * t - 10));
export const outExpo: Ease = (t) => ((t = clamp(t)) === 1 ? 1 : 1 - 2 ** (-10 * t));
export const inOutExpo: Ease = (t) => {
    t = clamp(t);
    if (t === 0 || t === 1)
        return t;
    return t < 0.5 ? 2 ** (20 * t - 10) / 2 : (2 - 2 ** (-20 * t + 10)) / 2;
};
export const outBack: Ease = (t) => {
    const c1 = 1.70158;
    const c3 = c1 + 1;
    t = clamp(t);
    return 1 + c3 * (t - 1) ** 3 + c1 * (t - 1) ** 2;
};
